import CommManagerInterface from '@/hosted_fields/master/interface';

export default interface PluginInterface {
  config: PluginConfig;
  init(): Promise<void>;
}

export enum PluginName {
  COMPONENTS_FIELDS = 'COMPONENTS_FIELDS',
  LOGGER = 'LOGGER',
  THREE_DOMAIN_SECURE = 'THREE_DOMAIN_SECURE',
  CHECKOUT_UTILS = 'CHECKOUT_UTILS',
  FUNCTIONS = 'FUNCTIONS',
  IDEAL = 'IDEAL',
  SOFORT = 'SOFORT',
  KBC_PAYMENT_BUTTON = 'KBC_PAYMENT_BUTTON',
  ELECTRONIC_PAYMENT_STANDARD = 'ELECTRONIC_PAYMENT_STANDARD',
  TRUSTLY = 'TRUSTLY',
  PAY_BY_BANK = 'PAY_BY_BANK',
  CASH_APP_PAY = 'CASH_APP_PAY',
  WECHAT_PAY = 'WECHAT_PAY',
  ALIPAY = 'ALIPAY',
  STABLECOIN = 'STABLECOIN',
  BANCONTACT = 'BANCONTACT',
  GOOGLE_PAY = 'GOOGLE_PAY',
  GIROPAY = 'GIROPAY',
  DOTPAY = 'DOTPAY',
  PAYPAL = 'PAYPAL',
  NETBANKING = 'NETBANKING',
  DIRECT_DEBIT = 'DIRECT_DEBIT',
  APPLE_PAY = 'APPLE_PAY',
  VENMO = 'VENMO',
  CAPTCHA = 'CAPTCHA',
  AMAZON_PAYMENTS = 'AMAZON_PAYMENTS',
  FASTER_PAYMENTS = 'FASTER_PAYMENTS',
  PAY_TO = 'PAY_TO',
  SEPA_INSTANT_TRANSFER = 'SEPA_INSTANT_TRANSFER',
  KLARNA_PAY_NOW = 'KLARNA_PAY_NOW',
  ONLINE_BANKING_POLAND = 'ONLINE_BANKING_POLAND',
  PAYCONIQ_BY_BANCONTACT = 'PAYCONIQ_BY_BANCONTACT',
  PIX = 'PIX',
}

export type PluginConfig = {
  site: string;
  hostname: string;
  publishableKey: string;
};
